import { IFeatureFlags } from 'types';
import { production } from './production';

// inherits production configuration
export const staging: IFeatureFlags = Object.assign({}, production, {});

Object.freeze(staging);
